<div
  [ngClass]="{
    wellbeing_padding: wellBeing && riskAlerts?.length,
    'risk-alerts-wrapper': riskAlerts?.length
  }"
>
  @if (riskAlerts?.length) {
    <div class="risk-alerts-header">
      <p>
        <span id="current-risk-title" i18n="@@CurrentRiskLevel">Current Risk Level</span
        ><span id="country-and-risk"
          >: {{ fullCountryName | translate }} - {{ highestRiskLevel | translate }}</span
        >
      </p>
      <span
        class="expanded_toggle_container"
        (click)="expanded = !expanded"
        (keydown.enter)="expanded = !expanded"
        role="button"
        tabindex="0"
        [attr.aria-expanded]="expanded"
        [attr.aria-label]="expanded ? 'Hide ' + (text | translate) : 'Show' + (text | translate)"
      >
        <span class="expanded_toggle">
          @if (expanded) {
            <span i18n="@@searchToggleState_hide" id="hide-risk">Hide</span>
          }
          @if (!expanded) {
            <span i18n="@@searchToggleState_show" id="show-risk">Show</span>
          }
          <span>&nbsp;{{ text | translate }}</span> </span
        ><i [ngClass]="expanded ? 'ico-tri-up' : 'ico-tri-down'" aria-hidden="true"></i>
      </span>
    </div>
  } @else {
    @if (highestRiskLevel) {
      <p>
        <span id="current-risk-title" i18n="@@CurrentRiskLevel">Current Risk Level</span
        ><span id="country-and-risk">: {{ fullCountryName }} - {{ highestRiskLevel }}</span>
      </p>
    }
  }

  @if (riskAlerts?.length && expanded) {
    <div class="flex-row-container risk-filter-container">
      <label for="risk-alert-search"><span class="sr-only">Risk Alerts&nbsp;</span>Search:</label>
      <input
        (keydown)="filterAlerts($event)"
        placeholder="Enter search terms..."
        i18n-placeholder
        id="risk-alert-search"
      />
    </div>
    <div class="risk-alerts-container" [ngClass]="{ full_container: fullyExpanded }">
      @for (alert of filteredRiskAlerts; track alert; let i = $index) {
        <div class="flex-row-container risk-alert">
          <div
            class="warning-block"
            [ngClass]="{
              'warning-block__moderate': alert.risk === 'Medium',
              'warning-block__extreme': alert.risk === 'Extreme',
              'warning-block__low': alert.risk === 'Low',
              'warning-block__high': alert.risk === 'High'
            }"
          ></div>
          <button (click)="showDetails(alert)" class="open_risk_button">
            <span class="visuallyhidden" i18n="@@riskOpen">Open risk alert</span>
            <b>{{ alert.risk }}</b>
            <span id="alert-title">&nbsp;-&nbsp;{{ alert.title }}</span>
          </button>
          <button
            class="close-alert-button"
            (click)="$event.stopPropagation(); removeAlert(i)"
            [attr.aria-label]="'Close ' + alert.title + ' risk alert'"
          >
            X
          </button>
        </div>
      }
    </div>
    <span
      class="expanded_toggle_container full_expanded_toggle"
      (click)="fullyExpanded = !fullyExpanded"
      (keydown.enter)="fullyExpanded = !fullyExpanded"
      role="button"
      tabindex="0"
      [attr.aria-expanded]="fullyExpanded"
    >
      <span class="expanded_toggle">
        @if (fullyExpanded) {
          <span i18n="@@fullyExpandedContract" id="contract">Contract</span>
        }
        @if (!fullyExpanded) {
          <span i18n="@@fullyExpandedExpand" id="expand">Expand</span>
        }
        <span class="visuallyhidden" i18n="@@riskAlertsContainer">risk information container</span>
      </span>
      <i [ngClass]="fullyExpanded ? 'ico-tri-up' : 'ico-tri-down'" aria-hidden="true"></i>
    </span>
  }
  @if (isLoading | async) {
    <div class="loading-container">
      <app-loading-spinner size="sm" /> <span class="loading-message" id="loading">Loading...</span>
    </div>
  }
</div>
